import { State } from '../../types';

export const arizona: State = {
  name: 'Arizona',
  abbreviation: 'AZ',
  terms: [
    {
      word: 'Agave',
      phonetic: 'uh-GAH-vee',
      description: 'A common desert plant name in the Southwest. Often mispronounced as "uh-GAH-vay."'
    },
    {
      word: 'Ahwatukee',
      phonetic: 'awe-wuh-too-kee',
      // audioUrl: '/audio/arizona.mp3',
      description: 'An east valley suburb of Phoenix.'
    },
    {
      word: 'Ajo',
      phonetic: 'awe-ho',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A small unincorporated community in Pima County, AZ and the Spanish word for garlic.'
    },
    {
      word: 'Aravaipa',
      phonetic: 'air-uh-vai-pa',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A canyon and town in southeast AZ. The word is Apache for "laughing waters".'
    },
    {
      word: 'Arizona',
      phonetic: 'air-ih-ZOH-nuh',
      // audioUrl: '/audio/arizona.mp3',
      description: 'State name pronunciation'
    },
    {
      word: "Barrio",
      phonetic: "BAH-ree-oh",
      description: "Spanish for neighborhood, commonly used in areas with significant Hispanic populations.",
    },
    {
      word: 'Cabeza Prieta',
      phonetic: 'Kuh-BAY-zuh PREE-eh-tah',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A wildlife refuge in southwestern Arizona, often mispronounced as Cuh-BEE-zah PREE-tuh.'
    },
    {
      word: 'Canyon de Chelly',
      phonetic: 'canyon duh-Shay',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A national monument located in the Navajo Nation in northeastern AZ.'
    },
    {
      word: 'Casa Grande',
      phonetic: 'cass-uhgrand',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A small city between Phoenix and Tucson.'
    },
    {
      word: 'Chiricahua',
      phonetic: 'chur-uh-kaa-wuh',
      // audioUrl: '/audio/arizona.mp3',
      description: 'The name of an Apache tribe and a national monument in southeastern AZ.'
    },
    {
      word: 'Cholla',
      phonetic: 'CHOY-uh',
      // audioUrl: '/audio/cholla.mp3',
      description: 'A type of cactus, pronounced "CHOY-uh," not "CHO-lah."'
    },
    {
      word: 'Coconino',
      phonetic: 'Koh-kuh-NEE-noh',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A national forest and large county in northern Arizona, commonly mispronounced as Koh-koh-NYE-noh.'
    },
    {
      word: "Cocopa",
      phonetic: "KO-ko-pah",
      description: "Referring to the Cocopa tribe, indigenous to the southwestern U.S. and northern Mexico.",
    },
    {
      word: 'Creosote',
      phonetic: 'KREE-uh-soht',
      description: 'The creosote bush, common in Southwestern deserts. Often mispronounced as "KREE-oh-soht."'
    },
    {
      word: 'Estrella',
      phonetic: 'ehs-treh-yah',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A mountain range with a park near Goodyear, AZ.'
    },
    {
      word: 'Fort Huachuca',
      phonetic: 'fort wa-CHOO-kuh',
      // audioUrl: '/audio/arizona.mp3',
      description: 'A military base in southern AZ.'
    },
    {
      word: 'Gila Monster',
      phonetic: 'he-luh monster',
      // audioUrl: '/audio/prescott.mp3',
      description: 'a species of venomous lizard native to the Southwestern United States and northwestern Mexico'
    },
    {
      word: "Hohokam",
      phonetic: "ho-ho-KAHM",
      description: "An ancient Native American culture that thrived in the area around Phoenix.",
    },
    {
      word: 'Hopi',
      phonetic: 'HO-pee',
      // audioUrl: '/audio/prescott.mp3',
      description: 'An indigenous tribe from what is now northeast AZ.'
    },
    {
      word: 'Houghton',
      phonetic: 'HOW-tin',
      // audioUrl: '/audio/houghton.mp3',
      description: 'A street in Tucson, pronounced "HOW-tin," not "HOUGH-ton."'
    },
    {
      word: 'Hualapai',
      phonetic: 'WAH-luh-pie',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A Native American tribe and reservation, often mispronounced as HOO-luh-pie.'
    },
    {
      word: 'Javelina',
      phonetic: 'HAH-vuh-LEE-nuh',
      // audioUrl: '/audio/prescott.mp3',
      description: 'Wild peccaries common in Arizona, often mispronounced as JAY-vuh-LEE-nuh.'
    },
    {
      word: "Kachina",
      phonetic: "kuh-CHEE-nuh",
      description: "A spirit or doll in Hopi and Puebloan cultures, representing ancestral spirits.",
    },
    {
      word: 'Kaibab',
      phonetic: 'KIE-bab',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A national forest, often mispronounced as KAY-bab or KIE-bob.'
    },
    {
      word: 'Kofa',
      phonetic: 'KOH-fuh',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A wildlife refuge, often mispronounced as KOFF-uh.'
    },
    {
      word: 'Lake Havasu City',
      phonetic: 'Lake HAH-vuh-soo',
      // audioUrl: '/audio/prescott.mp3',
      description: 'Known for the relocated London Bridge, often mispronounced as HAY-vuh-soo.'
    },
    {
      word: 'Maricopa',
      phonetic: 'Mare-uh-KO-puh',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A county and city, often mispronounced as Mare-ih-KOH-puh.'
    },
    {
      word: 'Mazatzal',
      phonetic: 'Mah-zaht-zahl',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A mountain range in central AZ. The word originates from ancient Mexican Indigenous culture translating to "land of the deer."'
    },
    {
      word: 'Mesa',
      phonetic: 'may-sa',
      // audioUrl: '/audio/prescott.mp3',
      description: 'An east valley suburb of Phoenix often mispronounced mess-uh.'
    },
    {
      word: 'Mogollon Rim',
      phonetic: 'moe-gee-yawn or mug-e-own rim',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A natural feature that runs across central AZ and seperates the low desert basin & range province from the high desert plateau and represents the southwestern edge of the Colorado Plateau.'
    },
    {
      word: 'Montezuma',
      phonetic: 'MON-tuh-zoo-muh',
      description: 'A well-known castle in Arizona linked to Native American history, though not directly related to Montezuma himself.'
    },
    {
      word: 'Naco',
      phonetic: 'NAH-koh',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A border town, often mispronounced as NAY-koh.'
    },
    {
      word: 'Nogales',
      phonetic: 'noh-GAH-les',
      // audioUrl: '/audio/nogales.mp3',
      description: 'A city on the U.S.-Mexico border, pronounced "noh-GAH-les," not "noh-GAL-es."'
    },
    {
      word: 'Ocotillo',
      phonetic: 'OH-koh-TEE-yoh',
      // audioUrl: '/audio/prescott.mp3',
      description: 'Located in northwestern Arizona, often mispronounced as PAY-oot.'
    },
    {
      word: 'Paiute',
      phonetic: 'PIE-yoot',
      // audioUrl: '/audio/prescott.mp3',
      description: 'Located in northwestern Arizona, often mispronounced as PAY-oot.'
    },
    {
      word: 'Palo Verde',
      phonetic: 'PAH-loh VEHR-day',
      description: 'A common Southwestern desert tree name. Often mispronounced as "PAL-oh VER-dee."'
    },
    {
      word: 'Papago',
      phonetic: 'paw-puh-gow',
      // audioUrl: '/audio/prescott.mp3',
      description: "A former name for the Tohono O'odham people of Arizona. It literally means tepary-bean eater"
    },
    {
      word: 'Piestewa',
      phonetic: 'PYESS-tuh-wah',
      description: 'A mountain in Phoenix named after Lori Piestewa, the first Native American woman killed in combat while serving in the U.S. military.'
    },
    {
      word: 'Pima',
      phonetic: 'PEE-muh',
      // audioUrl: '/audio/pima.mp3',
      description: 'A county and Native American tribe, pronounced "PEE-muh," not "PIE-muh."'
    },
    {
      word: 'Pinal',
      phonetic: 'puh-NAL',
      // audioUrl: '/audio/prescott.mp3',
      description: 'a county in south central Arizona.'
    },
    {
      word: 'Prescott',
      phonetic: 'PRESS-kit',
      // audioUrl: '/audio/prescott.mp3',
      description: 'City in central Arizona'
    },
    {
      word: 'Sahuarita',
      phonetic: 'saa-wuh-ree-tuh',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A small town south of Tucson. The word means "little Saguaro."'
    },
    {
      word: 'Saguaro',
      phonetic: 'suh-WAR-oh',
      // audioUrl: '/audio/saguaro.mp3',
      description: 'Type of cactus native to Arizona'
    },
    {
      word: 'San Xavier',
      phonetic: 'san hah-VEE-air',
      // audioUrl: '/audio/san_xavier.mp3',
      description: 'As in San Xavier del Bac Mission, pronounced "san hah-VEE-air," not "san ex-ZAY-vee-er."'
    },
    {
      word: 'Sinagua',
      phonetic: 'SIN-ah-wah',
      description: 'A pre-Columbian culture that once thrived in central Arizona.'
    },
    {
      word: 'Sitgreaves',
      phonetic: 'SIT-greeves',
      // audioUrl: '/audio/saguaro.mp3',
      description: 'A national forest in northern Arizona, sometimes mispronounced as SIT-graves.'
    },
    {
      word: 'Sonoita',
      phonetic: 'soh-NOY-tah',
      // audioUrl: '/audio/sonoita.mp3',
      description: 'A town in Santa Cruz County, pronounced "soh-NOY-tah," not "soh-no-EE-tah."'
    },
    {
      word: 'Supai',
      phonetic: 'SOO-pie',
      description: 'A remote village in the Grand Canyon, home to the Havasupai tribe.'
    },
    {
      word: 'Teec Nos Pos',
      phonetic: 'Tease-NAHS-pas',
      // audioUrl: '/audio/saguaro.mp3',
      description: 'A small outpost in the northeast corner of AZ.Translates to "Trees in a Circle" in Navajo. The name comes from cottonwoods that grow around water near the trading posts location.'
    },
    {
      word: 'Tempe',
      phonetic: 'tim-PEE',
      // audioUrl: '/audio/saguaro.mp3',
      description: 'A city in the Phoenix metropolitan area and home of Arizona State University.'
    },
    {
      word: 'Tlaquepaque',
      phonetic: 'tuh-laa-kuh-paw-kee',
      // audioUrl: '/audio/saguaro.mp3',
      description: 'An arts and crafts village/shopping center in Sedona.'
    },
    {
      word: "Tohono O'Odham",
      phonetic: 'Thaw-haw-naw Awe-awe-thumb',
      // audioUrl: '/audio/saguaro.mp3',
      description: 'A Native American tribe from the Sonoran Desert region. They are also known as the "Desert People"'
    },
    {
      word: "Tonto",
      phonetic: "TAHN-toh",
      description: "A name used for a basin and forest area, referencing the Tonto Apache group.",
    },
    {
      word: 'Tucson',
      phonetic: 'TOO-sawn',
      // audioUrl: '/audio/prescott.mp3',
      description: 'City in south central Arizona'
    },
    {
      word: 'Tusayan',
      phonetic: 'TOO-say-ahn',
      // audioUrl: '/audio/prescott.mp3',
      description: 'A small town near the Grand Canyon, mispronounced as TOO-sigh-an or TOO-say-in'
    }
  ]
};
